import { useQuery, useQueryClient } from "@tanstack/react-query";
import { snakeCase } from "lodash";
import useUploadListener from "../../../hooks/upload/useUploadListener";
import { advancedSearchKeys, FETCH_USER_LIST } from "../../samples/queryKeys";
import { Selections } from "../@types";
import api from "../api";
import { AVAILABLE_TRUE_QP } from "../consts";
import { constructQuery, constructSelections } from "../util";

const useFetchUserList = (q?: string, selections?: Selections) => {
  const queryClient = useQueryClient();

  useUploadListener(() =>
    queryClient.invalidateQueries({ queryKey: [FETCH_USER_LIST] })
  );

  return useQuery({
    queryKey: advancedSearchKeys.fetchUserList({ q, selections }),
    queryFn: () =>
      api.fetchUserList({
        q: q ? constructQuery(q, AVAILABLE_TRUE_QP) : "",
        ...constructSelections(selections, snakeCase)
      })
  });
};

export default useFetchUserList;
